import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72b9a6ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-style-panel" }
const _hoisted_2 = { class: "row tr_row" }
const _hoisted_3 = { style: {"flex":"2"} }
const _hoisted_4 = { class: "row tr_row" }
const _hoisted_5 = { style: {"flex":"2"} }
const _hoisted_6 = { class: "row tr_row" }
const _hoisted_7 = { style: {"flex":"2"} }
const _hoisted_8 = { class: "row tr_row" }
const _hoisted_9 = { style: {"flex":"2"} }
const _hoisted_10 = { class: "row tr_row" }
const _hoisted_11 = { style: {"flex":"2"} }

import { Ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTLineElement } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import { useI18n } from 'vue-i18n'
import ElementShadow from '../common/ElementShadow.vue'
import ColorButton from '../common/ColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import {
  InputNumber,
  Divider,
  Popover,
  Select,
} from 'ant-design-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LineStylePanel',
  setup(__props) {

const { t, locale } = useI18n()

const SelectOption = Select.Option

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const handleLineElement = handleElement as Ref<PPTLineElement>

const { addHistorySnapshot } = useHistorySnapshot()

const updateLine = (props: Partial<PPTLineElement>) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props })
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.style`)) + "：", 1),
      _createVNode(_unref(Select), {
        style: {"flex":"3"},
        value: _unref(handleLineElement).style,
        onChange: _cache[0] || (_cache[0] = value => updateLine({ style: value as 'solid' | 'dashed' }))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectOption), { value: "solid" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.solid`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(SelectOption), { value: "dashed" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.dotted`)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.color`)) + "：", 1),
      _createVNode(_unref(Popover), { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: _unref(handleLineElement).color,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = value => updateLine({ color: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(handleLineElement).color,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.weight`)) + "：", 1),
      _createVNode(_unref(InputNumber), {
        value: _unref(handleLineElement).width,
        onChange: _cache[2] || (_cache[2] = value => updateLine({ width: value as number })),
        style: {"flex":"3"}
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.startStyle`)) + "：", 1),
      _createVNode(_unref(Select), {
        style: {"flex":"3"},
        value: _unref(handleLineElement).points[0],
        onChange: _cache[3] || (_cache[3] = value => updateLine({ points: [value as 'arrow' | 'dot', _unref(handleLineElement).points[1]] }))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectOption), { value: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.none`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(SelectOption), { value: "arrow" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.arrow`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(SelectOption), { value: "dot" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.dot`)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.endStyle`)) + "：", 1),
      _createVNode(_unref(Select), {
        style: {"flex":"3"},
        value: _unref(handleLineElement).points[1],
        onChange: _cache[4] || (_cache[4] = value => updateLine({ points: [_unref(handleLineElement).points[0], value as 'arrow' | 'dot'] }))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectOption), { value: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.none`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(SelectOption), { value: "arrow" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.arrow`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(SelectOption), { value: "dot" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.lineStylePanel.dot`)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createVNode(_unref(Divider)),
    _createVNode(ElementShadow)
  ]))
}
}

})